export default {
  MuiTab: {
    styleOverrides: {
      root: {
        color: '#000000',
        '&:focus': {
          opacity: 1
        },
        padding: '0 0px 0px 0px',
        '&$selected': {
          color: '#000000',
          fontWeight: 'bold'
        },
        '&.Mui-selected': {
          color: '#000000'
        },
        fontSize: '1rem',
        minWidth: '53px !important',
        minHeight: '40px',
        marginRight: '16px'
      },
      textColorInherit: {
        color: 'rgba(0, 0, 0, 0.5)'
      }
    }
  }
};
